import { createContext, useContext } from 'react';

export const ModalContext = createContext(null);

export const ModalProvider = ModalContext.Provider;

export const useModalContext = () => useContext(ModalContext);
